import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import { CouponImportFileHdrHelperContainerModel } from '../../../../../../models/aggregates/erp/coupon/bl_fi_mst_coupon_import_file_helper_container.model';

@Injectable({
  providedIn: 'root'
})
export class CouponImportFileHelperService extends BaseApiTemplateService<CouponImportFileHdrHelperContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'coupons/import-file-helpers/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'coupons/import-file-helpers/backoffice-ep';
    this.httpClient = http;
  }
}
